import React from 'react'
import { Typography } from '@material-ui/core'
import { FlatButton } from 'shared/mui-styles';

const classes = {
    imgStyle: {
        width: 85,
        position: 'absolute',
        top: 8,
        left: 27.2,
    },
    h1: {
        marginBottom: '1rem'
    },
    btn: {
        marginTop: '5rem'
    }
}

const Notfound = (props) => (
    <div style={{ height: '100vh', backgroundColor: 'white' }} className="body-center">
        <img src={require('assets/imgs/house-atl.svg')} style={classes.imgStyle} alt="" />
        <div className="d-flex flex-column align-items-center">
            <Typography style={classes.h1} variant="h1">404</Typography>
            <Typography variant="h5">Sorry, page not found.</Typography>
            <FlatButton
                style={classes.btn}
                variant="outlined"
                onClick={() => { props.history.push('/') }}
            >
                Return to homepage
            </FlatButton>
        </div>
    </div>
)

export default Notfound